<!-- Loading State with Shimmer -->
<div *ngIf="loading" class="loader-container">
    <!-- Task Item Skeleton 1 -->
    <div class="loading-block task-skeleton">
        <div class="text-placeholder animated-background w-70 placeholder-description-height"></div>
        <div class="text-placeholder animated-background w-70 placeholder-description-height mt-1"></div>
        <!-- Images Placeholder -->
        <div class="flex-display mt-1">
            <div class="text-placeholder animated-background placeholder-image"></div>
            <div class="text-placeholder animated-background placeholder-image ml-1"></div>
        </div>

        <!-- Tags/Chips Placeholder -->
        <div class="flex-display mt-1">
            <div class="text-placeholder animated-background placeholder-chip"></div>
            <div class="text-placeholder animated-background placeholder-chip ml-1"></div>
            <div class="text-placeholder animated-background placeholder-chip ml-1"></div>
        </div>

        <!-- Task Type Badge -->
        <div class="text-placeholder animated-background placeholder-badge"></div>
    </div>

    <!-- Task Item Skeleton 2 -->
    <div class="loading-block task-skeleton">
        <div class="text-placeholder animated-background w-70 placeholder-description-height"></div>
        <div class="text-placeholder animated-background w-70 placeholder-description-height mt-1"></div>

        <!-- Tags/Chips Placeholder -->
        <div class="flex-display mt-1">
            <div class="text-placeholder animated-background placeholder-chip"></div>
            <div class="text-placeholder animated-background placeholder-chip ml-1"></div>
        </div>

        <!-- Task Type Badge -->
        <div class="text-placeholder animated-background placeholder-badge"></div>
    </div>

    <!-- Task Item Skeleton 3 -->
    <div class="loading-block task-skeleton">
        <div class="text-placeholder animated-background w-70 placeholder-description-height"></div>
        <div class="text-placeholder animated-background w-70 placeholder-description-height mt-1"></div>

        <!-- Images Placeholder -->
        <div class="flex-display mt-1">
            <div class="text-placeholder animated-background placeholder-image"></div>
            <div class="text-placeholder animated-background placeholder-image ml-1"></div>
            <div class="text-placeholder animated-background placeholder-image ml-1"></div>
        </div>

        <!-- Tags/Chips Placeholder -->
        <div class="flex-display mt-1">
            <div class="text-placeholder animated-background placeholder-chip"></div>
            <div class="text-placeholder animated-background placeholder-chip ml-1"></div>
            <div class="text-placeholder animated-background placeholder-chip ml-1"></div>
            <div class="text-placeholder animated-background placeholder-chip ml-1"></div>
        </div>

        <!-- Task Type Badge -->
        <div class="text-placeholder animated-background placeholder-badge"></div>
    </div>
</div>

<!-- Error State -->
<div *ngIf="error && !loading" class="alert alert-danger">
    <i class="fa fa-exclamation-triangle"></i> {{ error }}
</div>

<!-- Empty State -->
<div *ngIf="!loading && !error && tasks.length === 0" class="text-center empty-state">
    <i class="fa fa-inbox fa-3x"></i>
    <p>No {{ tab }} tasks found</p>
</div>

<!-- Tasks List -->
<div *ngIf="!loading && !error && tasks.length > 0">
    <ng-container *ngFor="let task of tasks">
        <div class="item-container"
             [ngClass]="{'task-mandatory': !task.skipTask && tab === 'incomplete'}">
            <div class="header">
                <h5>{{ task.description }}</h5>
                <span *ngIf="tab === 'incomplete'" class="delete-btn" (click)="deleteTask(task)">Delete</span>
            </div>
        <span class="description" *ngIf="task.type">{{ task.description2 }}</span>

        <!-- Photos for completed tasks -->
        <div *ngIf="tab === 'completed' && task.photos && task.photos.length > 0" class="img-container">
            <img *ngFor="let photo of task.photos; let i = index"
                 [src]="photo.url"
                 [alt]="photo.name"
                 [title]="photo.name" (click)="viewImage(task.photos, i)"/>
        </div>

        <!-- Assets -->
        <div *ngIf="task.assets && task.assets.length > 0" class="chip">
            <span *ngFor="let asset of task.assets"
                  class="hastag"
                  [title]="asset.asset_identifiers">
                {{ asset.asset_identifiers }}
            </span>
        </div>

        <!-- Tags -->
        <div *ngIf="task.tags && task.tags.length > 0" class="chip">
            <span *ngFor="let tag of task.tags"
                  class="hastag"
                  [style.background-color]="tag.colour"
                  [style.color]="'#fff'">
                #{{ tag.name }}
            </span>
        </div>

        <!-- Task Type Badge -->
        <div class="chip">
            <span class="time-slot">
                {{ task.type }}
            </span>
        </div>

        <!-- Skip warning for skipped tasks -->
            <div *ngIf="tab === 'skipped' && task.feedback && task.feedback.trim().length > 0" class="skip-warning">
            <i class="fa-solid fa-triangle-exclamation"></i>
            <span> {{ task.feedback }}</span>
        </div>
    </div>
    </ng-container>
</div>

<!-- Delete Task Confirmation Modal -->
<cs-modal [formGroup]="deleteConfirmationForm" [show]="showDeleteConfirmationModal" data-backdrop="static">
    <ng-container *ngIf="showDeleteConfirmationModal">
        <!-- Modal header -->
        <div class="modal-header">
            <button type="button" class="close" (click)="closeDeleteConfirmModal()">×</button>
            <h4 translate>Delete on-site task</h4>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
            <div class="row-fluid-delete">
                <p>
                    <span translate>job.delete.on-site.task.from.appointment.message</span>
                </p>
                <p>
                    <span translate [translateParams]="{word:'on-site task'}">To.confirm.delete.below.timeline.and.click.delete</span>
                </p>
            </div>
            <div class="input-prepend box-shadow input-fullwidth row-fluid-delete">
                <span class="add-on">
                    <span class="ss-caution"></span>
                </span>
                <div class="input-wrapper">
                    <input type="text" formControlName="confirmationText" class="modalDeleteNumber" (keyup.enter)="confirmDelete()" />
                </div>
            </div>
            <validation-error [formGroup]="deleteConfirmationForm" controlName="confirmationText" showOnDirty="true">
                <div class="row-fluid-delete">
                    <span translate [translateParams]="{word:'DELETE',message:'delete the task'}">confirmation.warning.text</span>
                </div>
            </validation-error>
        </div>

        <!-- Modal footer -->
        <div class="modal-footer">
            <div *ngIf="action != 'deleting'">
                <span *ngIf="action == 'failed_to_delete'" class="control-error-message">
                    <span translate>failed.to.perform.operation</span>
                </span>
                <a href="javascript:void(0)" class="btn btn-cancel" (click)="closeDeleteConfirmModal()" translate>Close</a>
                <button type="button" (click)="confirmDelete()"
                        [disabled]="deleteConfirmationForm.invalid || action == 'deleting'" class="btn btn-danger btn-medium"
                        translate>Delete
                </button>
            </div>
        </div>
    </ng-container>
</cs-modal>
